<!-- eslint-disable no-undef -->
<template>
  <div
    class="width-100 min-height bg-image flex-column align-items-center justify-content-start position-relative padding-lr-15"
    id="body-div"
    style="background: #f7f7f7"
  >
    <van-swipe class="my-swipe width-100" :autoplay="3000" indicator-color="white">
      <van-swipe-item v-for="(item, key) in itemDetail.picture_arr" :key="key">
        <van-image :src="item" width="100%" :height="(bodyWidth - 30) * 0.9 + 'px'" />
      </van-swipe-item>
    </van-swipe>
    <div class="width-100 padding-15 br-reg margin-t15 bg-white flex-column align-items-center justify-content-center">
      <div class="width-100 flex-row align-items-baseline justify-content-start">
        <div style="color: #f29c33" class="fs-mid-big">
          {{ itemDetail.integral }}
        </div>
        <div class="fs-mid darkgrey">积分</div>
      </div>
      <div class="width-100 flex-row align-items-center justify-content-spaceBetween margin-tss">
        <div class="flex-row align-items-baseline justify-content-center">
          <div class="fs-mid-sml grey-999 margin-r">原价</div>
          <div class="fs-sml grey-999" style="text-decoration: line-through">{{ itemDetail.original_price }}元</div>
        </div>
        <div class="flex-row align-items-baseline justify-content-center">
          <div class="fs-mid-sml grey-999 margin-r">已兑</div>
          <div class="fs-sml grey-999">
            {{ itemDetail.redeemed_num }}
          </div>
        </div>
      </div>
      <div class="width-100 fw-bold fs-big margin-tss">
        {{ itemDetail.name }}
      </div>
      <div class="width-100 darkgrey fs-mid-sml margin-tss" v-if="itemDetail.introduce">
        {{ itemDetail.introduce }}
      </div>
      <div class="width-100 darkgrey fs-mid-sml margin-tss" v-if="itemDetail.is_limit_new_user_exchange == 1">
        仅限{{ itemDetail.new_user_time }}之后注册的用户兑换
      </div>
      <div class="width-100 darkgrey fs-mid-sml margin-tss" v-if="itemDetail.is_limitation_exchange_region == 1">
        仅限{{ itemDetail.exchange_region_name }}的用户兑换
      </div>
    </div>
    <div class="width-100 padding-15 br-reg margin-t15 bg-white flex-row align-items-center justify-content-center">
      <div class="width-100 flex-column align-items-center justify-content-center">
        <div class="flex-row align-items-center justify-content-spaceBetween width-100">
          <div style="width: 50px; height: 50px" class="br-rol overflow-h">
            <van-image width="50px" height="50px" fit="contain" :src="itemDetail.shop_logo" />
          </div>
          <div class="width-80 fs-mid-sml">
            {{ itemDetail.shop_name }}
          </div>
        </div>
        <div class="width-100 show-line-1 canNotWrap fs-sml margin-ts">营业时间：{{ itemDetail.shop_business_hours }}</div>
        <div class="width-100 show-line-1 canNotWrap fs-sml margin-ts">地址：{{ itemDetail.shop_address }}</div>
        <div class="width-100 show-line-1 canNotWrap fs-sml margin-ts">商家号码：{{ itemDetail.shop_phone }}</div>
      </div>
      <!-- <div class="width-20">12</div> -->
    </div>
    <div class="width-100 br-reg margin-t15 bg-white padding-15" v-if="itemDetail.details">
      <div class="width-100 flex-row align-items-center justify-content-center textAlign-c fs-mid-sml fw-bold border-b">商品详情</div>
      <div class="width-100" v-html="itemDetail.details"></div>
    </div>
    <div style="height: 100px; width: 100%"></div>
    <div class="width-100 bg-white padding-15 flex-row align-items-center justify-content-spaceBetween" style="position: fixed; bottom: 0; left: 0">
      <div class="width-15 flex-column align-items-center justify-content-center" @click="$router.replace('/home')">
        <van-image :src="require('../assets/image/home/home.png')" width="1.5rem" height="1.5rem" />
        <div class="fs-mid-sml">首页</div>
      </div>
      <div
        class="width-70 bg-yellow br-big flex-row align-items-center justify-content-spaceBetween"
        :style="{
          background: itemDetail.time_state == 1 ? '#FFFEF0' : 'linear-gradient(to right,#E3E3E3,#F3F3F3)',
          padding: '5px',
          borderRadius: '2.5rem'
        }"
      >
        <div style="height: 2.5rem" class="flex-column width-50 align-items-center justify-content-around">
          <div class="fs-mid" :style="{ color: itemDetail.time_state == 1 ? '#FF7001' : '#999' }">{{ itemDetail.integral }}积分</div>
          <div class="flex-row align-items-center justify-content-center">
            <div :style="{ color: itemDetail.time_state == 1 ? '#FF7001' : '#999' }" class="fs-sml">门市价：</div>
            <div :style="{ textDecoration: 'line-through', color: itemDetail.time_state == 1 ? '#FF7001' : '#999' }" class="fs-sml">
              {{ itemDetail.original_price }}元
            </div>
          </div>
        </div>
        <div
          @click="duihuan1"
          class="width-50 br-big textAlign-c fs-mid-sml"
          :style="{
            background: itemDetail.time_state == 1 ? 'linear-gradient(to right,#FFB101,#FF7001)' : 'linear-gradient(to right,#FFFFFF,#E2E2E2)',
            height: '2.5rem',
            lineHeight: '2.5rem',
            color: itemDetail.time_state == 1 ? '#fff' : '#333'
          }"
        >
          {{ itemDetail.time_state == 1 ? '兑换' : itemDetail.time_state == 2 ? '已结束' : '未开始' }}
        </div>
      </div>
    </div>
    <van-overlay :show="show" class="flex-row align-items-center justify-content-center">
      <div class="bg-white padding-lr-15 br-reg width-70 flex-column align-items-center justify-content-center">
        <div style="margin-top: -40px" class="margin-b15">
          <van-image :src="require('../assets/image/sweepstakesPage/truefinish.png')" width="80px" height="80px" />
        </div>
        <div class="fs-mid-big fw-bold margin-b15">恭喜您兑换成功</div>
        <div
          class="br-reg white textAlign-c width-90 fs-big"
          style="background: linear-gradient(to right, #ffb101, #ff7001); line-height: 2.5rem"
          @click="$router.push({ path: '/prizeManagement' })"
        >
          前往核销
        </div>
        <div @click="show = false" class="textAlign-c width-90 fs-big margin-bs margin-ts" style="line-height: 2.5rem; color: #f67600">完成</div>
      </div>
    </van-overlay>
    <van-dialog v-model="showDuiHuan" @confirm="duihuan" show-cancel-button @cancel="showDuiHuan = false">
      <div class="width-100 textAlign-c padding-15 fs-20" style="border-bottom: 1px solid #eee">是否要兑换{{ itemDetail.name }}</div>
    </van-dialog>
  </div>
</template>

<script>
import { get_member_info } from '@/api/home';
import { get_goods_details, exchange_goods } from '@/api/point_mall';
import { Toast } from 'vant';
export default {
  data() {
    return {
      show: false,
      bodyWidth: '',
      bodyHeight: '',
      showDuiHuan: false,
      itemDetail: {},
      isEnd: false,
      placeObj: {
        province: '',
        city: '',
        region: '',
        addr: ''
      }
    };
  },
  async beforeMount() {
    const _this = this;
    await get_member_info()
      .then((res) => {
        if (res.code == 0) {
          this.userInfo = res.data;
          this.$store.commit('setUserInfo', { ...res.data });
        } else {
          this.$router.replace({ path: '/login', query: { path: 'point_mall_detail', id: this.$route.query.id } });
        }
      })
      .catch((err) => console.log(err));
    this.$nextTick(() => {
      this.bodyWidth = document.getElementById('body-div').clientWidth;
      this.bodyHeight = document.getElementById('body-div').clientHeight;
    });
    get_goods_details({ id: this.$route.query.id }).then((res) => {
      if (res.code == 0) {
        this.itemDetail = res.data;
        console.log(new Date(this.$dayjs(res.data.end_time)));
        let time = new Date(this.$dayjs(res.data.end_time));
        let time2 = new Date();
        document.title = res.data.column_name;
        if (res.data.is_limitation_exchange_region == 1) {
          /* eslint-disable no-undef,no-unused-vars */
          CP.getLocationInfo({
            completed: function (data) {
              // data > {'time': '1234567891','lat': '','lon':'','radius':'','province': '','city':'上海市','region':'','addr':'','speed':'','accuracy': '', 'timestamp': ''}
              if (data.lat == '' || data.lon == '') {
                Toast('您暂未开启定位权限');
              }
              _this.placeObj = data;
            },
            cpIncompatible: function () {
              Toast('您暂时没有权限或者暂未开启定位权限');
            }
          });
        }
        if (time.getTime() - time2.getTime() > 0) {
          this.itemDetail.start = true;
        } else if (time.getTime() - time2.getTime() < 0) {
          this.isEnd = true;
        }
      } else {
        this.$router.back();
      }
    });
  },
  methods: {
    duihuan1() {
      if (this.itemDetail.time_state == 2) {
        return;
      }
      if (this.itemDetail.time_state == 1) {
        this.showDuiHuan = true;
      }
    },
    duihuan() {
      const _this = this;
      if (this.itemDetail.stock <= 0) {
        Toast('该商品库存不足');
        return;
      }
      if (
        (this.placeObj.lat == '' || this.placeObj.lon == '' || this.placeObj.lat == undefined || this.placeObj.lon == undefined) &&
        this.itemDetail.is_limitation_exchange_region == 1
      ) {
        Toast('您暂未开启定位权限');
        return;
      }
      // eslint-disable-next-line no-undef
      CP.getUniqueId({
        completed: (data) => {
          Toast.loading({
            message: '兑换中,请稍后...',
            forbidClick: true
          });
          exchange_goods({
            session_id: data.unique_id,
            id: this.itemDetail.id,
            ..._this.placeObj,
            address: _this.placeObj.province + _this.placeObj.city + _this.placeObj.region + _this.placeObj.addr
          }).then((res) => {
            if (res.code == 0) {
              this.point = res.data;
              this.show = true;
            } else {
              Toast(res.msg);
            }
            setTimeout(() => {
              Toast.clear();
            }, 500);
          });
        },
        cpIncompatible: () => {
          Toast('此环境不支持此方法');
        }
      });
    }
  }
};
</script>

<style scoped>
</style>